import { Pipe, PipeTransform } from '@angular/core';
import { TipoProfissionalEnum } from '@app/features-modules/bolsa-de-profissionais/api';

@Pipe({
  name: 'tipoProfissionalDesc'
})
export class TipoProfissionalDescPipe implements PipeTransform {

  transform(value: TipoProfissionalEnum | string | undefined, returnType: 'text' | 'icon' = 'text'): string {
    if (!value) return returnType === 'text' ? 'Desconhecido' : 'fa-solid fa-question-circle';

    if (returnType === 'icon') {
      return TipoProfissionalEnumIcons[value as TipoProfissionalEnum] || 'fa-solid fa-question-circle';
    }

    return TipoProfissionalEnumDescriptions[value as TipoProfissionalEnum] || 'Desconhecido';
  }

}

// Mappings for descriptions
export const TipoProfissionalEnumDescriptions: { [key in TipoProfissionalEnum]: string } = {
  1: "Individual",
  2: "Recém Formado",
  3: "Bolseiro"
};

// Mappings for icons (Font Awesome or Material Icons)
export const TipoProfissionalEnumIcons: { [key in TipoProfissionalEnum]: string } = {
  1: "pi pi-user-minus",
  2: "pi pi-graduation-cap",
  3: "pi pi-user"
};
